import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { helpCategories } from "../help/helpData";
import HelpCenterLayout from "../help/HelpCenterLayout";
import Breadcrumbs from "../help/Breadcrumbs";
import "../../css/HelpCenter.css";

const HELP_BASE_PATH = "/help-archive";

const HelpArchiveLanding = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "VelaKoda | Help Center Archive";
  }, []);

  return (
    <HelpCenterLayout backFallbackTo="/help">
      <Breadcrumbs items={[{ label: "All Collections" }]} />

      <header className="help-page-header">
        <h1 className="help-page-title">Help Center Archive</h1>
        <p className="help-page-subtitle">
          Browse the archived copy of the help center for future reference.
        </p>
      </header>

      <div className="help-collection-grid">
        {helpCategories.map((category) => (
          <div key={category.id} className="help-collection-card">
            <div className="help-collection-card-copy">
              <div className="help-collection-card-label">
                {category.displayTitle}
              </div>
              <div className="help-collection-card-title">{category.title}</div>
              <div className="help-collection-card-description">
                {category.summary}
              </div>
              <div className="help-collection-card-meta">
                {category.articles.length} articles
              </div>
            </div>
            <button
              type="button"
              className="help-collection-card-action"
              onClick={() => navigate(`${HELP_BASE_PATH}/${category.id}`)}
            >
              View collection
            </button>
          </div>
        ))}
      </div>
    </HelpCenterLayout>
  );
};

export default HelpArchiveLanding;
